//Articles Template

//Key "graphic" looking within the images folder
//Example of graphicReposition = 50% 40%; this is optional

const articleBulletins = {
  "key": "w02",
  "title": "Church Bulletin Subscription Designs",
  "skills": "Graphic Design | Typography | Digital Imaging | Project Management",
  "date": "2014 - 2019",
  "path": "bulletins",
  "graphic": "religious/DIW20B05.jpg",
  "graphicReposition": "50% 6%",
  "content": [
    {
      "component": "Title",
      "content": "Church Bulletin Subscription Designs"
    },
    {
      "component": "Subheading",
      "design": "centered",
      "content": "Graphic Design | Typography | Digital Imaging | Project Management"
    },
    {
      "component": "Body",
      "design": "centered",
      "content": "2016-2019, I played an integral role in creating a unique product for church customers at Dexter Press. We produced 3 different 52-week church bulletin series that churches could purchase on a subscription basis. My role was to assist in the design of this product line while reducing the workload and costs associate with delivering the product."
    },
    {
      "component": "Subheading",
      "content": "I supported product design by...",
      "design": "centered"
    },
    {
      "component": "List",
      "listType": "unordered",
      "content": [
        "curating which scripture content to use each week",
        "sourcing imagery for each week (occasionally conducting photography)",
        "doing the bulk of the design work",
        "bringing on team members to help",
        "collaborating with designers (providing art direction, getting their feedback)",
        "managing all the files"
      ]
    },
    {
      "component": "Subheading",
      "content": "I helped improve our product and processes by...",
      "design": "centered"
    },
    {
      "component": "List",
      "listType": "unordered",
      "content": [
        "automating repetitive design processes",
        "templatizing files",
        "training prepress on typesetting scripture",
        "cooperating cross-departmentally",
        "putting more eyes on final design approvals"
      ]
    },
    {
      "component": "Body",
      "design": "caption centered",
      "content": "Below, you'll find the designs we did for the 2020 DIW (Designs in Worship) series."
    },
    {
      "component": "Gallery",
      "galleryType": "grid",
      "content": [
        {
          "source": "religious/DIW20A01.jpg",
        },
        {
          "source": "religious/DIW20A02.jpg",
        },
        {
          "source": "religious/DIW20A03.jpg",
        },
        {
          "source": "religious/DIW20A04.jpg",
          "caption": "The stylization of the text could really make or break the design. Despite the simplicity of this design's text, we used an alternative font and had it stand out to give the final design that finished look."
        },
        {
          "source": "religious/DIW20A05.jpg",
        },
        {
          "source": "religious/DIW20A06.jpg",
        },
        {
          "source": "religious/DIW20A07.jpg",
        },
        {
          "source": "religious/DIW20A08.jpg",
        },
        {
          "source": "religious/DIW20A09.jpg",
        },
        {
          "source": "religious/DIW20A10.jpg",
        },
        {
          "source": "religious/DIW20A11.jpg",
        },
        {
          "source": "religious/DIW20A12.jpg",
        },
        {
          "source": "religious/DIW20A13.jpg",
        },
        {
          "source": "religious/DIW20B01.jpg",
        },
        {
          "source": "religious/DIW20B02.jpg",
        },
        {
          "source": "religious/DIW20B03.jpg",
        },
        {
          "source": "religious/DIW20B04.jpg",
          "caption": "We kept our designs looking fresh and modern year over year. This simplistic yet enviting cover is a direct result of our efforts to keep our product line marketable and relevant."
        },
        {
          "source": "religious/DIW20B05.jpg",
          "caption": "Each image was color corrected to enhance the vibrance and quality of the image. For this one, we brought out the rainbow, field, and rich sky."
        },
        {
          "source": "religious/DIW20B06.jpg",
          "caption": "For the DIW series, we selected verses that paired nicely with each Sunday of the calendar year. For other series like WELS and WOW, we selected verses that went along with the Revised Common Lectionery readings for that Sunday."
        },
        {
          "source": "religious/DIW20B07.jpg",
        },
        {
          "source": "religious/DIW20B08.jpg",
        },
        {
          "source": "religious/DIW20B09.jpg",
        },
        {
          "source": "religious/DIW20B10.jpg",
        },
        {
          "source": "religious/DIW20B11.jpg",
        },
        {
          "source": "religious/DIW20B12.jpg",
        },
        {
          "source": "religious/DIW20B13.jpg",
          "caption": "Our designs were for a Christian American audience. This design lines up with Independence Day."
        },
        {
          "source": "religious/DIW20C01.jpg",
        },
        {
          "source": "religious/DIW20C02.jpg",
          "caption": "Verses were selected first. Creating a strong visual connection to the verse was critical for emphasizing the message."
        },
        {
          "source": "religious/DIW20C03.jpg",
        },
        {
          "source": "religious/DIW20C04.jpg",
        },
        {
          "source": "religious/DIW20C05.jpg",
        },
        {
          "source": "religious/DIW20C06.jpg",
        },
        {
          "source": "religious/DIW20C07.jpg",
        },
        {
          "source": "religious/DIW20C08.jpg",
        },
        {
          "source": "religious/DIW20C09.jpg",
          "caption": "You'll notice this series avoids showing pictures of people. Each series had it's own rules to follow that had long been established before I got there, and we had to make sure to adhere to them for our clients throughout the design process."
        },
        {
          "source": "religious/DIW20C10.jpg",
        },
        {
          "source": "religious/DIW20C11.jpg",
        },
        {
          "source": "religious/DIW20C12.jpg",
        },
        {
          "source": "religious/DIW20C13.jpg",
          "caption": "Designs for the DIW series were required to match KJV and NIV Bible translations. This was problematic because these two translations read very differently. I spent a lot of time making careful editorial decisions on what text from the verses we would display on the cover designs, often resulting in fragments and ellipsis to carry the written ideas across."
        },
        {
          "source": "religious/DIW20D01.jpg",
        },
        {
          "source": "religious/DIW20D02.jpg",
        },
        {
          "source": "religious/DIW20D03.jpg",
        },
        {
          "source": "religious/DIW20D04.jpg",
        },
        {
          "source": "religious/DIW20D05.jpg",
        },
        {
          "source": "religious/DIW20D06.jpg",
        },
        {
          "source": "religious/DIW20D07.jpg",
        },
        {
          "source": "religious/DIW20D08.jpg",
        },
        {
          "source": "religious/DIW20D09.jpg",
        },
        {
          "source": "religious/DIW20D10.jpg",
        },
        {
          "source": "religious/DIW20D11.jpg",
        },
        {
          "source": "religious/DIW20D12.jpg",
        },
        {
          "source": "religious/DIW20D13.jpg",
        },
        {
          "source": "religious/DSA20D09.jpg",
          "caption": "I took these Advent photographs for the December season. In cases where it was challenging to source imagery, we would have to make it ourselves. Other series occasionally used illustrations."
        },
        {
          "source": "religious/DSA20D10.jpg",
        },
        {
          "source": "religious/DSA20D11.jpg",
        },
        {
          "source": "religious/DSA20D12.jpg",
        }
      ]
    }
  ]
}


export default articleBulletins;